import { useOfferPageContext } from 'pages/offer/context';
import { CardVariant } from '../types';
import { Typography, TypographyType } from './typography';
import { Spacing, SpacingSize, SpacingDirection } from './spacing';
import styles from './main-tasks.module.scss';
import { Card, ListWithDots } from '.';

/**
 * List of tasks
 */
export const MainTasks = () => {
  const {
    userData: { mainTasks },
  } = useOfferPageContext();

  if (!mainTasks) {
    return null;
  }

  return (
    <Spacing size={SpacingSize.medium} direction={SpacingDirection.vertical} className={styles.mainTasks}>
      <Typography type={TypographyType.h2}>Основные задачи</Typography>

      <Card variant={CardVariant.benefit}>
        <div className={styles.task} dangerouslySetInnerHTML={{ __html: mainTasks }} />
      </Card>
    </Spacing>
  );
};
